import { AxiosInstance } from 'axios';

/** One object a cleanup deleted, would delete, or could not delete. Mirrors ScenarioCleanupAction. */
export interface ScenarioCleanupAction {
    system?: string;
    kind?: string;
    id?: string;
    outcome?: 'wouldDelete' | 'deleted' | 'failed' | 'leftBehind';
    detail?: string;
}

/** What a cleanup found and did. Mirrors ScenarioCleanupReport. */
export interface ScenarioCleanupReport {
    customer?: string;
    environment?: string;
    target?: string;
    applied?: boolean;
    customerCount?: number;
    actions?: ScenarioCleanupAction[];
}

/**
 * Asks the API to delete what scenario runs created, or only to list it.
 *
 * Written by hand next to the generated client, like the other endpoints that arrived after it was last
 * regenerated. Without a run id it covers every scenario customer of the environment.
 */
export const cleanupScenarioData = async (
    axios: AxiosInstance,
    customer: string,
    environment: string,
    runId: string | undefined,
    apply: boolean
): Promise<ScenarioCleanupReport> => {
    const response = await axios.post(
        `/ScenarioRun/${encodeURIComponent(customer)}/${encodeURIComponent(
            environment
        )}/cleanup`,
        { runId, all: !runId, apply },
        { headers: { 'Content-Type': 'application/json' } }
    );

    // The axios instance is created with transformResponse: [], so response.data is a string and has to be parsed here.
    return typeof response.data === 'string'
        ? (JSON.parse(response.data) as ScenarioCleanupReport)
        : (response.data as ScenarioCleanupReport);
};
